import React from 'react';
import ReactDOM from 'react-dom/client';
import { initAnalytics } from './analytics';
import './config/i18n';
import './index.css';
import App from './App';

initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
